module.exports = __webpack_public_path__ + "img/katarina_bathrooms_9.8e68044f.jpg";